import { render, staticRenderFns } from "./CanalCobroList.vue?vue&type=template&id=a71ec888"
import script from "./CanalCobroList.vue?vue&type=script&lang=js"
export * from "./CanalCobroList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports